export default __webpack_public_path__ + "static/media/zebras.cc09e965.jpg";